module.exports = __webpack_public_path__ + "img/colored-square.bb69c970.svg";